import { TSearchPortalContact } from '../searchPortalContact'

export const normalizedSearchPortalData = (data: TSearchPortalContact): TSearchPortalContact => {
  const emailLower = data.emailAddress.toLowerCase()
  const emailNormalized = emailLower.startsWith('stg.') ? emailLower.slice(4) : emailLower

  return {
    ...data,
    emailAddress: emailNormalized,
  }
}
